import * as CryptoJS from 'crypto-js';
import { PhoneNumbersUtils } from '../core/utilities/phone-numbers-helpers';

export class MessagingHelper {
  static getGroupKeyUniqueKey(
    primaryNumber: string,
    secondaryNumber: string,
    numbers: string[],
    messageId?: string,
  ): [string[], string, string] {
    primaryNumber = PhoneNumbersUtils.phoneNumberToInternational(primaryNumber);
    secondaryNumber = PhoneNumbersUtils.phoneNumberToInternational(secondaryNumber);

    const groupNumbers = new Set(numbers.map(x => PhoneNumbersUtils.phoneNumberToInternational(x)));
    groupNumbers.add(primaryNumber);
    groupNumbers.add(secondaryNumber);
    const groupNumbersArray = Array.from(groupNumbers).sort();

    const uniqueKey = !!messageId
      ? CryptoJS.MD5(`${primaryNumber}${secondaryNumber}${messageId}`).toString()
      : undefined;

    const groupKey = CryptoJS.MD5(`${primaryNumber}${groupNumbersArray.join('')}`)
      .toString();

    return [groupNumbersArray, groupKey, uniqueKey];
  }
}
